<template>
  <div class="tab-content">
    <v-row>
      <v-chip
        v-for="hive in selectedHives"
        class="ma-2 hive-chip"
        color="#EFF0F6"
        text-color="#4E4B66"
      >
        <v-icon
          left
          @click="selectHive(hive.id)"
        >mdi-close</v-icon>
        {{hive.hiveNumber}}
      </v-chip>
    </v-row>
  </div>
</template>

<script>
  import {mapGetters, mapActions} from 'vuex';

  export default {
    name: 'ActionsHivesTab',
    computed: {
      ...mapGetters(["selectedHives"]),
    },
    methods: {
      ...mapActions(["selectHive"])
    }
  }
</script>

<style type="text/css">
  #actions-card .hive-chip {
    width: 60px;
    height: 28px;
    padding: 3px 10px;
    font-size: 13px;
    line-height: 22px;
    font-weight: 500;
    letter-spacing: 0.25px;
    justify-content: center;
    border-radius: 8px;
  }
</style>